<template>
  <div class="edit-event">
    <div class="text-with-line text-with-line_blue-bg"><span>{{ $t('index.journal.edit.setUpNewEvent') }}</span></div>

    <form ref="form" class="event" @submit.prevent="createNewEvent">
      <!--      верхняя часть без комментариев и вложений-->
      <div class="event-head">
        <div class="inputs">

          <div class="inputs-item">
            <eventTypeIcon/>
            <div class="select-cont select-cont_filter select-cont_small-green no-actions">
              <p v-if="isClearType" class="label no-type">
                {{$t('labels.requiredField')}}
              </p>
              <p v-else class="label">
                {{$t('index.journal.edit.enterEventType')}}
              </p>
              <v-select :searchable="true"
                        v-model="eventType"
                        :clearable="false"
                        :taggable="true"
                        :pushTags="true"
                        @input="changeSelect"
                        label="Тип события"
                        placeholder="Тип события"
                        :options="eventTypeOptions"></v-select><!--@input="createOption"-->
            </div>
          </div>
        </div>
        <div class="date">
          {{ date }}
        </div>
      </div>
      <div class="event-footer">
        <button type="button"
                class="btn btn-transparent_blue"
                @click="cancel">
          {{ $t('index.journal.edit.cancelButton') }}
        </button>
        <button type="submit"
                class="btn btn-blue"
                :class="{'loading': loading}" :disabled="$v.$anyError || disabled || loading">
          <!--@click="setNewEventType"-->
          {{ $t('index.journal.edit.createEventButton') }}
        </button>
      </div>
    </form>

    <transition name="fade" mode="out-in">
      <div v-show="newEvent.textBlock" class="text-block textarea-wrap">
        <label class="input-cont text-block__heading" :class="{'error': $v.eventTitle.$error}">
          <input type="text"
                 v-model.trim="eventTitle"
                 @blur="$v.eventTitle.$touch()"
                 @focus="$v.eventTitle.$reset()"
                 >
          <errors v-show="$v.eventTitle.$error" type="standart"></errors>
        </label>

        <vue-editor v-model="customText"
                    useCustomImageHandler
                    class="my-editor"
                    :editorOptions="editorSettings"
                    @image-added="uploadEditorImage"
                    @image-removed="removeEditorImage"
                    @text-change="textChange"></vue-editor>
        <button @click="removeTextBlock()" class="delete-button">
          {{ $t('index.journal.edit.delBlock') }}
          <remBtnNoBG/>
        </button>
      </div>
    </transition>

    <!--    нижняя часть: комментарии, вложения, добавить блок информации-->
    <transition name="fade" mode="out-in">
      <div v-if="newEvent.commentsBlock" class="info-block comments-block">
        <div class="comments"><span>0 </span>{{ $t('index.journal.edit.commentsInside') }}</div>
        <button @click="removeCommentsBlock()" class="delete-button">
          {{ $t('index.journal.edit.delBlock') }}
          <remBtnNoBG/>
        </button>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="newEvent.enclosureBlock" class="info-block attachment-block">
        <div class="comments"><span>0 </span>{{ $t('index.journal.edit.filesInside') }}</div>
        <button @click="removeEnclosureBlock()" class="delete-button">
          {{ $t('index.journal.edit.delBlock') }}
          <remBtnNoBG/>
        </button>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <button v-if="!newEvent.enclosureBlock || !newEvent.commentsBlock || !newEvent.textBlock"
              class="add-block"
              @click="showInfoBlockAddModal"
      >
        <plusIconSmall/>
        {{ $t('index.journal.edit.addInfoBlock') }}
      </button>
    </transition>
  </div>
</template>

<script>
import {toFormData} from "../../../mixins/utils/toFormData";
import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
import {showOverlay} from '../../../mixins/utils/showOverlay'
import {validate} from "../../../mixins/utils/validate";

import thingIcon from '../../../components/Svg/journal/thingIcon'
import eventTypeIcon from '../../../components/Svg/journal/eventTypeIcon'
import remBtnNoBG from '../../../components/Svg/journal/remBtnNoBG'
import plusIconSmall from '../../../components/Svg/journal/plusIconSmall'
import addInfoBlock from '../../Popups/journal/addInfoBlock'
import addNewJournal from '../../Popups/journal/addNewJournal'
import errors from '../../Forms/errors'

import {mapState,mapMutations, mapGetters, mapActions} from 'vuex'
import {required} from "vuelidate/lib/validators";
import {editorConfig} from "@/mixins/editorConfig";

  export default {
    name: "editEvent",
    mixins: [
      showOverlay,
      validate,
      toFormData,
      tokenAndRoute,
      editorConfig
    ],
    components: {
      thingIcon,
      eventTypeIcon,
      remBtnNoBG,
      plusIconSmall,
      addInfoBlock,
      errors,
      addNewJournal
    },
    data() {
      return {
        loading: false,
        text: 'fsdfsd dsf sd sd sd fsd f',
        options: {
          theme: 'Roman'
        },
        eventTypeOptions: [],
        thingOptions: [],
        checkForChangeLabel: false,

        editor: '',
        removeFilesIds: '',
        imageUrl: null,
        imageId: '',
        imagesArr: [],
        textAlignButtons: null
      }
    },
    computed: {
      ...mapState({
        token: state => state.auth.token,
        eventTypeData: state => state.journal.eventType,
        eventTemplates: state => state.journal.eventTemplates,
        eventTypes: state => state.journal.eventTypes,
        isClearType: state => state.journal.isClearType,
        tempData: state => state.journal.tempData,
        typeCreate: state => state.journal.typeCreate,
      }),
      ...mapGetters({
        newEvent: 'journal/event'
      }),
      date() {
        const date = new Date()
        const options = {
          day: 'numeric',
          month: 'long',
          hour: 'numeric',
          minute: 'numeric'
        };

        return date.toLocaleString("ru", options)
      },
      disabled() {
        return this.eventType === '' // || !this.thing
      },
      eventTitle: {
        get() {
          return this.newEvent.eventTitle
        },
        set(val) {
          this.setEventTitle(val)
        }
      },
      textContent: {
        get() {
          return this.newEvent.textContent
        },
        set(val) {
          this.setTextContent(val)
        }
      },
      eventType: {
        get() {
          return this.eventTypeData
        },
        set(val) {
          this.setEventType(val)
        }
      },
      thing: {
        get() {
          return this.newEvent.thing
        },
        set(val) {
          this.setThing(val)
        }
      },
    },
    validations: {
      eventTitle: {
        required
      },
      eventType: {
        required
      }
    },
    watch: {
      newEvent() {
        this.setTexts()
      },
      'newEvent.textBlock'() {
        this.setTexts()
      },
    },
    methods: {
      ...mapActions({
        createEvent: 'journal/createEvent',
        getEvents: 'journal/getEvents',
        getEventTemplates: 'journal/getEventTemplates',
        getEventTypes: 'journal/getEventTypes',
        uploadFile: 'global/uploadFile',
        removeFile: 'global/removeFile',
      }),
      ...mapMutations({
        showModalBlock: 'popups/addInfoBlock/SET_SHOW',
        setEventType: 'journal/SET_EVENT_TYPE',
        setThing: 'journal/SET_THING',
        setTextBlock: 'journal/SET_TEXT_BLOCK',
        setTextContent: 'journal/SET_TEXT_CONTENT',
        setEventTitle: 'journal/SET_EVENT_TITLE',
        setCommentsBlock: 'journal/SET_EVENT_COMMENTS_BLOCK',
        setEnclosureBlock: 'journal/SET_EVENT_ENCLOSURE_BLOCK',
        resetEvent: 'journal/RESET_EVENT',
        setClearType: 'journal/SET_CLEAR_TYPE',
        setTempData: 'journal/SET_TEMP_DATA',
        setTypeCreate: 'journal/SET_TYPE_CREATE',
      }),
      async uploadEditorImage(file, Editor, cursorLocation) {
        let data = {
          files: file
        }
        let formData = this.toFormData(data)
        await this.uploadFile(formData).then(data => {
          this.imageUrl = data[0].filepath;
          this.imageId = data[0].id;
          this.imagesArr.push({
            id: data[0].id,
            url: data[0].filepath
          });
          Editor.insertEmbed(cursorLocation, "image", data[0].filepath);
        })
      },
      removeEditorImage(image) {
        let id = 0;
        this.imagesArr.forEach((item) => {
          if (item.url === String(image)) {
            id = item.id
          }
        })
        if (this.removeFilesIds === '') {
          this.removeFilesIds = id;
        } else {
          this.removeFilesIds += ', ' + id;
        }
      },
      textChange(delta, oldDelta, source) {
        if (!this.undoRedoFlag) {
          if (this.customText.indexOf(this.imageUrl) !== -1 && this.imageUrl !== null) {
            document.querySelector('.ql-editor').innerHTML = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.customText = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.imageUrl = null
          }

          this.history.splice(this.position, 1000000)
          this.history.push(this.customText)
          this.position++
        }
        this.undoRedoFlag = false

      },
      changeSelect() {
        let data = {
          device_id: this.routeId,
          type: this.eventType,
          content: JSON.stringify(this.event),
          name: ''
        }
        this.setTempData(data)
        this.setTypeCreate(this.eventType)
      },
      setTexts() {
        if (this.newEvent.textBlock === true) {
          if (this.eventTitle === '') {
            this.eventTitle = this.$t('index.journal.edit.eventTypeTitle')
          }
         } else {
          this.eventTitle = ''
        }
      },
      removeTextBlock() {
        this.setTextBlock(false)
      },
      removeCommentsBlock() {
        this.setCommentsBlock(false)
      },
      removeEnclosureBlock() {
        this.setEnclosureBlock(false)
      },
      showInfoBlockAddModal() {
        this.showOverlay(true)
        this.showModalBlock(true)
      },
      async createNewEvent() {
        this.loading = true
        this.textContent = this.customText

      let data = {
        device_id: this.routeId,
        type: this.eventType,
        content: JSON.stringify(this.newEvent),
        title: JSON.stringify(this.newEvent.eventTitle),
        text: JSON.stringify(this.textContent),
      }

      if (this.removeFilesIds !== '') {
        let removeFileData = {
          ids: this.removeFilesIds
        }
        await this.removeFile(removeFileData);
      }

      let formData = this.toFormData(data)
      await this.createEvent(formData).then(()=> {
        this.$refs.form.reset()
        this.customText = '';
        this.resetEvent()
        this.getEvents({id: this.routeId})
        this.$router.push(`/journals/journal-${this.routeId}`)
        this.loading = false
      })
      },
      cancel() {
        this.customText = ''
        this.resetEvent()
        window.history.back();
      }
    },
    mounted() {
      this.textAlignButtons = document.querySelectorAll('.ql-align')
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          let divArr = document.querySelector('#quill-container').childNodes
          divArr[3].style.left = '-2000px'
        }
      })

      this.setLabels();
      this.getEventTypes(this.$route.params.id).then(res => {
        let array = [...this.eventTypes]
        let arr = []
        array.splice(0, 1)
        array.map(item => {
          arr.push(item.name)
        })
        this.eventTypeOptions = arr
        if (this.typeCreate) {
          this.eventType = this.typeCreate
          let data = {
            device_id: this.routeId,
            type: this.eventType,
            content: JSON.stringify(this.event),
            name: ''
          }
          this.setTempData(data)
        }
      })
    },
    beforeDestroy() {
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          btn.removeAttribute("onclick")
        }
      })
      this.textAlignButtons = null
    },
    destroyed() {
      this.resetEvent()
    }
  }
</script>

<style lang="scss">
.edit-event {
  .delete-button {
    svg path {
      transition: all .3s;
    }

    &:hover {
      color: $red;

      svg path {
        fill: $red;
      }
    }
  }
}
</style>

<style lang="scss" scoped>

.edit-event {
  max-width: 800px;
  margin: auto;
}

.text-with-line, .text-with-line-center {
  margin-bottom: 20px;
}

.text-with-line_blue-bg span {
  @extend %regularDarkBlue
}

.event {
  margin-bottom: 10px;
  padding: 20px 30px 25px 30px;
  background: #FFFFFF;
  box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
  border-radius: 8px;

  .event-head {
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid $ultraLightBlue;

    .date {
      @extend %regularDarkBlue;
    }
  }

  .select-cont {
    position: relative;

    .v-select {
      width: 180px;
    }
  }

  .inputs {
    display: flex;
  }

  .inputs-item {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 20px;

    &:first-child {
      margin-right: 20px;
    }

    svg {
      margin-right: 5px;
      position: absolute;
      left: -5px;
      top: 10px;
    }

    .label {
      position: absolute;
      top: -13px;
      left: 5px;
      z-index: 1;
      font-size: 12px;
      line-height: 24px;
      color: $green;
      background-color: white;
      padding: 0 5px;
    }
  }
}

.text-block {
  margin-bottom: 10px;
  padding: 30px;
  background: #FFFFFF;
  box-shadow: 0 4px 12px rgba(0, 82, 127, 0.2);
  border-radius: 8px;

  &__heading {
    margin-bottom: 30px;
  }

  &__content {
    color: $darkBlue;
    font-family: $mm;
    font-weight: 500;
    font-size: 13px;
    line-height: 165%;
    padding-bottom: 30px;
    border-bottom: 1px solid $ultraLightBlue;
  }

  .delete-button {
    margin-left: auto;
    padding-top: 30px;
  }
}

.medium-editor-element {
  color: #00527F;
  font-family: MM, Arial, sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 165%;
  padding-bottom: 30px;
  border-bottom: 1px solid #EFF3F6;
}

.input-cont input {
  padding: 10px;
  background: #E9F0F4;
  border-radius: 4px;
  border-color: transparent;
  @extend %headingDarkBlue;
  font-size: 24px;
}

.event-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 29px;
}

.btn {
  max-width: 200px;
}

.btn-blue {
  margin-left: 20px;
}

.info-block {
  @extend %regularDarkBlue;
  display: flex;
  justify-content: space-between;
  padding: 19px 30px;
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 10px;
}

.delete-button {
  display: flex;
  align-items: center;
  @extend %regularLightBlue;

  svg {
    margin-left: 10px;

    &:hover {
      fill: blue;
    }
  }

  &:hover {
    color: #ED1C24;

    svg {
      path {
        fill: red;
      }
    }
  }

  &:hover {
    color: red;
  }

  &:hover .delete-button {
    svg path {
      fill: blue;
    }
  }
}

.add-block {
  padding: 19px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @extend %regularLightBlue;
  border: 1px dashed $blue;
  border-radius: 8px;

  svg {
    margin-right: 10px;
  }
}

.no-type {
  color: red !important;
}

</style>


